import Vue from "vue";
import axios from "axios";

const initState = {
  currentPage: "index",
  index: {
    campaigns: [],
    queries: {
      per_page: 10,
      page: 1,
      status: "active",
      search: null,
      sort_by: "id",
      sort_desc: false,
    },
  },
  view: {
    campaign: null,
    episodes: [],
    queries: {
      per_page: 10,
      page: 1,
      status: "active",
      search: null,
      sort_by: "id",
      sort_desc: false,
    },
  },
  archived: {
    campaigns: [],
    queries: {
      per_page: 10,
      page: 1,
      status: "archived",
      search: null,
      sort_by: "id",
      sort_desc: false,
    },
    total: 0,
  },
};

export default {
  namespaced: true,

  state: Vue.util.extend({}, initState),

  mutations: {
    getAllSuccess(state, { campaigns, page, queries, total }) {
      state[page] = {
        campaigns: campaigns,
        queries: queries,
        total: total,
      };
    },
    currentPage(state, page) {
      state.currentPage = page;
    },
    getAllEpisodeSuccess(state, { episodes, page, queries, total }) {
      state[page] = {
        episodes: episodes,
        queries: queries,
        total: total,
      };
    },
    getAllSponsorAudioSuccess(state, { sponsorAudios, page, queries, total }) {
      Vue.set(state, "sponsorAudios", sponsorAudios);
      state.datatable = {
        queries: queries,
        total: total,
      };
    },
  },
  actions: {
    deleteFile({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            `/podcast/campaign/${data.campaign_id}/delete-file?type=${data.type}`
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    uploadPodcastImageFile({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/podcast/${formData.get("podcast_id")}/upload-image`, formData)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    report_usage({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/podcast/${formData.segment_id}/report-usage`, {
            duration: formData.duration,
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    uploadFile({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `/podcast/campaign/${formData.get("campaign_id")}/upload`,
            formData
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    uploadCampaignImageFile({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `/podcast/campaign/${formData.get("campaign_id")}/upload-image`,
            formData
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    archive({ commit }, episode_id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/podcast/${episode_id}/archive`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteCampaignImage({ commit }, campaign) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/podcast/campaign/${campaign.id}/delete-image`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    saveVar({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/podcast/campaign/${formData.campaign_id}/save-var`, formData)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    resetAll({ commit }) {
      commit("resetAllSuccess");
    },
    find({ commit }, pageId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/podcast/campaign/${pageId}`)
          .then((res) => {
            this.campaign = res.data.data;
            resolve(res.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    playSegment({ commit }, segment) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/podcast/play-segment/${segment.podcast_id}`, segment)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    process({ commit }, episode) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/podcast/episode/${episode.id}/process`, episode)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    save({ commit }, episode) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/podcast/episode/${episode.id}/save`, episode)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    generateScript({ commit }, episode) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/podcast/episode/${episode.id}`, episode)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteEpisodeImage({ commit }, episode) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/podcast/episode/${episode.id}/delete-image`, episode)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getEpisode({ commit }, pageId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/podcast/episode/${pageId}`)
          .then((res) => {
            resolve(res.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    voices({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/podcast/voices/${data.user_id}`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createVoice({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/create-custom-voice/${data.user_id}`, data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    removeFavorite({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/remove-favorite/${data.voice.favorite_id}`, data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    removeClone({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/remove-clone/${data.voice.id}`, data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateFavorite({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/update-favorite/${data.voice.favorite_id}`, data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateClone({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/update-clone/${data.voice.id}`, data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    saveFavorite({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/save-favorite`, data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    publicLink({ commit }, episode) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/podcast/${episode.id}/public-link`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    exportPodcast({ commit }, episode) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/podcast/${episode.id}/export-podcast`, {
            responseType: "blob",
          })
          .then((res) => {
            const blob = new Blob([res.data], { type: "application/pdf" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "podcast_export.pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendApproval({ commit }, approvalData) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `/podcast/${approvalData.episodeId}/send-approval`,
            approvalData
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    schedulePubDate({ commit }, episode) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/${episode.id}/schedule-pubdate`, {
            scheduled_publish_at: episode.scheduled_publish_at,
            scheduled_timezone: episode.scheduled_timezone,
            is_save: episode.isSave,
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updatePubDate({ commit }, episode) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/${episode.id}/update-pubdate`, {
            published_at: episode.pub_date,
            timezone: episode.timezone,
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    togglePublish({ commit }, episode) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/${episode.id}/toggle-publish`, {
            published_at: episode.pub_date,
            timezone: episode.timezone,
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setCurrentPage({ commit }, page) {
      commit("currentPage", page);
    },
    saveSettings({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/campaign/${data.campaign_id}/save-settings`, data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAISuggestions({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/ai-suggestions`, data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createCampaign({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/create-campaign`, data)
          .then((res) => {
            this.campaign = res.data;
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    quickCreateCampaign({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/quick-create-campaign`, data)
          .then((res) => {
            this.campaign = res.data;
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createPodcast({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/create-episode/${data.campaign_id}`, data.episode)
          .then((res) => {
            this.campaign = res.data;
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllEpisodes({ commit, state }, { queries, page, campaign_id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`podcast/campaign/${campaign_id}/episodes`, { params: queries })
          .then((res) => {
            commit("getAllEpisodeSuccess", {
              episodes: res.data.data,
              page: page,
              queries: queries,
              total: res.data.meta.total,
            });
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAll({ commit, state }, { queries, page }) {
      return new Promise((resolve, reject) => {
        axios
          .get("podcast/campaigns", { params: queries })
          .then((res) => {
            commit("getAllSuccess", {
              campaigns: res.data.data,
              page: page,
              queries: queries,
              total: res.data.meta.total,
            });
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    uploadSponsorAudio({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `/podcast/${formData.get("podcast_id")}/upload-sponsor-audio`,
            formData
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    uploadCommercialAudio({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `/podcast/episode/${formData.get(
              "episode_id"
            )}/upload-commercial-audio`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              maxContentLength: Infinity,
              maxBodyLength: Infinity,
            }
          )
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    generateCommercialAudio({ commit }, { prompt, episode_id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/podcast/episode/${episode_id}/generate-commercial-audio`, {
            prompt,
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteCommercialAudio({ commit }, { episode_id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/podcast/episode/${episode_id}/delete-commercial-audio`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  getters: {
    total(state) {
      return state[state.currentPage].total;
    },
    content(state) {
      return state.create.content;
    },
    queries(state) {
      return state[state.currentPage].queries;
    },
    all(state) {
      return state[state.currentPage].campaigns;
    },
    episodes(state) {
      return state[state.currentPage].episodes;
    },
  },
};
